import { CF_MODAL_TYPE_DICTIONARY } from "../constants";
import { CfModalProps } from "../types";
import { convertCfBackgroundProps } from "utilities/cfPropTypes/cfBackground";
import { convertCfSpacersProps } from "utilities/cfPropTypes/cfSpacers";
import Modal from "..";
import React from "react";

export const convertCfModalProps = ({
  id,
  customClass,
  modalStyle,
  children,
}: CfModalProps) => {
  return {
    customClass: customClass || "",
    id,
    children,
    modalType: modalStyle?.modalType
      ? CF_MODAL_TYPE_DICTIONARY?.[modalStyle.modalType]
      : "",
    ...convertCfBackgroundProps(modalStyle?.background),
    ...convertCfSpacersProps(modalStyle?.spacers),
  };
};

const CfModal = (props: CfModalProps) => {
  return <Modal {...convertCfModalProps(props)} />;
};

export default CfModal;
